/* <judgeme-write> — our "Write a review" button, wired to Judge.me.

   Judge.me has no modal form. Its widget ships a hidden `.jdgm-write-rev-link`
   and clicking it expands a form INSIDE that widget, so the button has to:

     1. open the collapsed widget host  — a `display: none` host is never laid
        out, Judge.me's loader skips it, and the click then does nothing at all;
     2. click the link;
     3. wait, because the form does not exist at click time.

   If the form never appears — Judge.me blocked or slow — the widget is opened and
   scrolled to anyway, so Judge.me's own controls are in front of the shopper. It
   does NOT navigate away: a slow script is not a reason to leave the product page.
   With no JS at all the anchor is a plain link to /pages/reviews. */
const FORM = '.jdgm-form-wrapper, .jdgm-form, .jdgm-rev-widg__form, .jdgm-write-rev-link + form';

class JudgeMeWrite extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('[data-jm-write]');
    if (this.btn) this.btn.addEventListener('click', (e) => this.open(e));
  }

  open(e) {
    const host = document.querySelector('[data-jm-host]');
    const link = document.querySelector('.jdgm-write-rev-link');
    if (!host || !link) return;                 // no widget here — follow the href
    e.preventDefault();
    host.classList.add('is-open');
    link.click();

    const deadline = Date.now() + 2500;
    const find = () => {
      const form = document.querySelector(FORM);
      if (form && form.offsetParent !== null) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const first = form.querySelector('input:not([type=hidden]), textarea, select');
        if (first) { try { first.focus({ preventScroll: true }); } catch (_) { first.focus(); } }
        return;
      }
      if (Date.now() < deadline) { requestAnimationFrame(find); return; }
      // Judge.me produced no form in time. Show its widget rather than navigating:
      // a slow script is not a reason to yank someone off the product they are on,
      // and the widget carries Judge.me's own write control.
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    requestAnimationFrame(find);
  }
}
if (!customElements.get('judgeme-write')) customElements.define('judgeme-write', JudgeMeWrite);
